module.exports = __webpack_public_path__ + "img/icon-lightbulb.120f5d3a.svg";